import { styleMap } from '@/view/weappTmp/core/lib/public/cssMap.js'
export function CSSTransition (sourceData = {}, sourceStyleMap = {}) {
  let nStyleMap = Object.assign({}, sourceStyleMap, styleMap)
  // console.log('nStyleMap1',nStyleMap)
  // nStyleMap = JSON.parse(JSON.stringify(nStyleMap))
  // console.log('nStyleMap2',nStyleMap)
  // console.log('CSSTransition-nStyleMap',styleMap,sourceStyleMap)
  let styleObj = {}
  for (let i in sourceData) {
    let style = nStyleMap[i]
    if (style && sourceData[i]) {
      if(typeof style === 'string' && nStyleMap[style] && sourceData[i] && typeof nStyleMap[style] == 'function'){
        style = nStyleMap[style]
         // type 用来标示是否为高级css；因为有可能该项样式 由多条css构成；
         let { type, key, value } = style(sourceData[i])
         type ? (styleObj = Object.assign(styleObj, value)) : (styleObj[key] = value)
      }else if (typeof style === 'string') {
        styleObj[style] = sourceData[i]
      } else if (typeof style === 'function' && sourceData[i]) {
        // type 用来标示是否为高级css；因为有可能该项样式 由多条css构成；
        let { type, key, value } = style(sourceData[i])
        type ? (styleObj = Object.assign(styleObj, value)) : (styleObj[key] = value)
      }
    }
  }
  // console.log('this.styleMerge', styleObj)
  return styleObj
}
